<template>
  <div class="main-container">
    
    <div>
    <div class="modal">
      <div class="modal-content" ref="modalBox">
        <div class="top-bar">
          <img @click="back" src="@/assets/path-2-copy.png" />
          <span class="heading_new">Company Policies</span>
        </div>
        <div class="popup-window-content-no-use">
          <div class="row"> 
            <div class="block-section-4 col-6">
                <div class="block-section-2">
                    <tl-header type="h3" class="title">
                            Standard of Conduct
                    </tl-header>
                    <div class="block-title-icon">
                        <div class="description-text"> COVID 19 Policy </div>
                        <div class="icon-arrow" style="cursor:pointer" @click="policyPopup()"><img src="@/assets/next-icon.png" alt/></div>
                    </div>
                    <div class="block-title-icon">
                        <div class="description-text"> Anti-harassment policy </div>
                        <div class="icon-arrow" style="cursor:pointer" @click="policyPopup()"><img src="@/assets/next-icon.png" alt/></div>
                    </div>
                    <div class="block-title-icon">
                        <div class="description-text"> Substance-free workplace policy </div>
                        <div class="icon-arrow" style="cursor:pointer" @click="policyPopup()"><img src="@/assets/next-icon.png" alt/></div>
                    </div>
                    <div class="block-title-icon">
                        <div class="description-text"> Dress Code </div>
                        <div class="icon-arrow" style="cursor:pointer" @click="policyPopup()"><img src="@/assets/next-icon.png" alt/></div>
                    </div>
                    <div class="block-title-icon">
                        <div class="description-text"> Taking disciplinary action </div>
                        <div class="icon-arrow" style="cursor:pointer" @click="policyPopup()"><img src="@/assets/next-icon.png" alt/></div>
                    </div>
                </div>
            </div>
            <div class="block-section-4 col-6">
                <div class="block-section-2">
                    <tl-header type="h3" class="title">
                            Communication Policies
                    </tl-header>
                    <div class="block-title-icon">
                        <div class="description-text"> Email </div>
                        <div class="icon-arrow" style="cursor:pointer" @click="policyPopup()"><img src="@/assets/next-icon.png" alt/></div>
                    </div>
                    <div class="block-title-icon">
                        <div class="description-text"> Social media (hangouts) </div>
                        <div class="icon-arrow" style="cursor:pointer" @click="policyPopup()"><img src="@/assets/next-icon.png" alt/></div>
                    </div>
                    <div class="block-title-icon">
                        <div class="description-text"> Mobile Number </div>
                        <div class="icon-arrow" style="cursor:pointer" @click="policyPopup()"><img src="@/assets/next-icon.png" alt/></div>
                    </div>
                </div>
            </div>
          </div>
          <div class="row"> 
            <div class="block-section-4 col-6">
                <div class="block-section-2">
                    <tl-header type="h3" class="title">
                            Office environment
                    </tl-header>
                    <div class="block-title-icon">
                        <div class="description-text"> Work hours </div>
                        <div class="icon-arrow" style="cursor:pointer" @click="policyPopup()"><img src="@/assets/next-icon.png" alt/></div>
                    </div>
                    <div class="block-title-icon">
                        <div class="description-text"> Your work-from-home policy </div>
                        <div class="icon-arrow" style="cursor:pointer" @click="policyPopup()"><img src="@/assets/next-icon.png" alt/></div>
                    </div>
                    <div class="block-title-icon">
                        <div class="description-text"> Lunch and break periods </div>
                        <div class="icon-arrow" style="cursor:pointer" @click="policyPopup()"><img src="@/assets/next-icon.png" alt/></div>
                    </div>
                    <div class="block-title-icon">
                        <div class="description-text"> ComOff Import </div>
                        <div class="icon-arrow" style="cursor:pointer" @click="policyPopup()"><img src="@/assets/next-icon.png" alt/></div>
                    </div>
                    <div class="block-title-icon">
                        <div class="description-text"> How to keep the workplace safe </div>
                        <div class="icon-arrow" style="cursor:pointer" @click="policyPopup()"><img src="@/assets/next-icon.png" alt/></div>
                    </div>
                    <div class="block-title-icon">
                        <div class="description-text"> Employees with Disabilities Act(ADA) accommodations </div>
                        <div class="icon-arrow" style="cursor:pointer" @click="policyPopup()"><img src="@/assets/next-icon.png" alt/></div>
                    </div>
                    <div class="block-title-icon">
                        <div class="description-text"> Use of company equipment </div>
                        <div class="icon-arrow" style="cursor:pointer" @click="policyPopup()"><img src="@/assets/next-icon.png" alt/></div>
                    </div>
                    <div class="block-title-icon">
                        <div class="description-text"> Leave Request Import </div>
                        <div class="icon-arrow" style="cursor:pointer" @click="policyPopup()"><img src="@/assets/next-icon.png" alt/></div>
                    </div>
                </div>
            </div>
            <div class="col-6"></div>
          </div> 
        </div>
      </div>
    </div>
  </div>
    
    <pop-up-window
        v-if="showPopupCompanyPoliciesPopup"
        @back="showPopupCompanyPoliciesPopup = !showPopupCompanyPoliciesPopup"
          :header="headerTitle"
        >
          <template v-slot:content>
            <company-policies-document
            @back="showPopupCompanyPoliciesPopup = !showPopupCompanyPoliciesPopup"
            
            :document="policyDocument" 
            >
            </company-policies-document>
         </template>
    </pop-up-window>

  </div>
</template>

<script>
import companyPoliciesDocument from './companyPoliciesDocument.vue';
import { mapActions, mapGetters, mapState } from "vuex";       
export default {
  name: "companyPolicies",  
  components: {
    'company-policies-document' : companyPoliciesDocument
  },
  data() {
    return {
      showPopupCompanyPoliciesPopup: false,
     headerTitle:"Comapany Policy",
     policyDocument:{type: Object},
    }
  },
  props: {
      header: {
        type: String
      },
      btnText: {
        type: String
      },
      popupType: {
        type: String,
        default: "Success"
      },
      popupHeaderMessage: {
        type: String,
        default: "Success"
      },
      closable: {
        type: Boolean,
        default: false
      },
      useDefaultHeader: {
        type: Boolean,
        default: true
      },
      animate: {
        type: Boolean,
        default: false
      },
      isModal: {
        type: Boolean,
        default: true
      },
      customStyle: {
        type: String,
        default: null
      },
  },
  mounted() {
    //   if(this.animate) {
    //     this.$root.$el.style.position = "absolute";
    //     this.$root.$el.style.overflow = "hidden";
    //     this.$root.$el.style.height = "100%";

        
    //   }
    },
    computed: {
    ...mapState({
      //globalEmployeeList: (state) =>
        //state.globalapi.globalemployees.entityWiseData,
    }),
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID"
    }),
    le_id() {
      if (this.$route.params.entity_index)
        return this.getleid(this.$route.params.entity_index);
      else return this.getleid(0);
    },
    ifHR() {
      return localStorage.getItem("userRole") == "HR" ? true : false;
    },
    ifEmployee() {
      return localStorage.getItem("userRole") == "EMPLOYEE" ? true : false;
    },
    ifAuditor() {
      return localStorage.getItem("userRole") == "AUDITOR" ? true : false;
    },
  },
    beforeDestroy() {
    //   if(this.animate) {
    //     this.$root.$el.style.position = "static";
    //     this.$root.$el.style.overflow = "visible";
    //     this.$root.$el.style.height = "auto";
    //   }
    },
  methods: {
    // navigateToDocuments(url){
    //   this.$router.push({
    //     path:url
    // });
    // },
    ...mapActions({
     
      fetchCompanyPolicy:"auth/fetchCompanyPolicy"
    }),
    back() {
      if(this.ifHR || this.ifEmployee) {
        this.$router.push({
            path: `/dashboard/${this.$route.params.entity_index}/overview`,
        });
      } else if(this.ifAuditor) {
        this.$router.push({
            path: `/dashboard/${this.$route.params.entity_index}/payroll/incometaxproofapproval`,
        });
      } else {
        this.$router.push({
            path: `/dashboard/${this.$route.params.entity_index}/payroll`,
        });
      }  
    },

    async policyPopup() {
      let res= await this.getPolicyDocument();
    // this.headerTitle= "Use of company equipment";
        //console.log(res);
        this.policyDocument=res;
      this.showPopupCompanyPoliciesPopup = true;
    },
     async getPolicyDocument(){
      try {
        //this.le=this.le_id;
        let res = await this.fetchCompanyPolicy({
          le_id: this.le_id,
          
        });
        //console.log("resss",res);
        return res.data;
        } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    
      }

  },
};
</script>


<style lang="scss" scoped>

.main-container {
    width: 100%;
    padding: 0px 0 0 0px;
    margin-bottom: 110px;
}

.block-section-4 {
    margin: 30px;
    padding: 0px;
    background: white;
    -webkit-box-flex: 1;
    -ms-flex-positive: 1;
    flex-grow: 1;
    -ms-flex: 1;
    flex: 1;
    height: auto;
    border: 2px solid #eeeeee;
    border-radius: 8px;
    -webkit-box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.06);
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.06);
}

.block-title-icon {
    margin: 20px 0px;
}

.description-text {
    font-size: 1.1rem;
    font-weight: 600;
    color: #5d409f;
    margin-left: 30px;
    width: 45%;
}

.icon-arrow {
    float: right;
    margin-right: 32px;
    transform: translate(0px, -18px);
}

.icon-arrow > img {
    height: 10px;
}

.title{
  padding: 20px;
}

.top-bar {
  height: 64px;
  width: 100%;
  //border-radius: 12px 12px 0px 0px;
  //display: flex;
  box-shadow: 0 1px 18px 0 rgba(0, 0, 0, 0.12);
  background-color: #ffffff;
  padding: 24px 0 24px 32px;
  img {
    cursor: pointer;
    margin-right: 24px;
    width: 10px;
    height: 16px;
  }
}

.heading_new {
  height: 19px;
  font-size: 16px;
  font-weight: 600;
  color: #6e6e6e;
}

@keyframes fadeInUp {
  0% {
    transform: rotate(360deg) translate3d(0, 50%, 0);
    opacity: 0;
  }
  60% {
    transform: rotate(360deg) translate3d(0, 0, 0);
    opacity: 1;
    margin-top: 110px;
  }
  100% {
    transform: rotate(360deg) translate3d(0, 0, 0);
    opacity: 1;
    margin-top: 120px;
  }
}
@-webkit-keyframes fadeInUp {
  0% {
    transform: rotate(360deg) translate3d(0, 50%, 0);
    opacity: 0;
  }
  60% {
    transform: rotate(360deg) translate3d(0, 0, 0);
    opacity: 1;
    margin-top: 110px;
  }
  100% {
    transform: rotate(360deg) translate3d(0, 0, 0);
    opacity: 1;
    margin-top: 120px;
  }
}
.animated {
  animation-duration: 0.4s !important;
  animation-iteration-count: 1 !important;
  animation-timing-function: ease-in !important;
  -webkit-animation-duration: 0.4s !important;
  -webkit-animation-iteration-count: 1 !important;
  -webkit-animation-timing-function: ease-in !important;
}
.fadeInUp {
  -webkit-animation-name: fadeInUp !important;
  animation-name: fadeInUp !important;
}


.modal {
//   display: block;
//   position: fixed;
//   z-index: 6;
//   left: 0px;
//   top: 0px;
  width: 100%;
  height: 100%;
//  overflow: hidden;
}

// .modalbg {
//   background: rgba(0, 0, 0, 0.60);
//   -webkit-backdrop-filter: blur(14px);
//   backdrop-filter: blur(10px);
// }

/* Modal Content */

.modal-content {
//   background-color: white;
//   margin: 120px auto 0px auto;
//   z-index: 20;
//   width: 80%;
//   height: calc(100% - 120px);
//   display: flex;
//   flex-direction: column;
//   align-items: flex-start;
//   border-radius: 12px 12px 0px 0px;
//   opacity: 1;

  .success-icon {
    // margin-bottom: 40px;
  }

  .success-text {
    font-weight: 600;
    // margin-bottom: auto;
    margin-left: 12px;
    color: #6e6e6e;
  }

  .message-text {
    margin-bottom: 40px;
    animation-delay: 0.7s;
    animation-name: fadeInRight;
    -webkit-animation-name: fadeInRight;
  }
  .btn-confirm-delete{
    display: flex;
    align-items: center;
    *:nth-child(n){
      margin-right: 20px;
    }
  }

  .btn-popup {
    display: block;
    border-radius: 4px;
    min-width: 150px;
    padding: 0px 10px;
    height: 35px;
 }
  .btn-popup-secondary {
    display: block;
    border-radius: 4px;
    min-width: 150px;
    padding: 0px 10px;
    height: 35px;
    background-color: #ffffff;
  }

  .close-btn {
    position: relative;
    transform: scale(2);
    left: 230px;
    bottom: 20px;
    cursor: pointer;
  }
}

.animated {
  animation-duration: 0.3s;
  -webkit-animation-duration: 0.3s;
}

@keyframes fadeOutDown {
  0% {
    transform: rotate(360deg) translate3d(0, 0, 0);
    opacity: 1;
  }
  40% {
    transform: rotate(360deg) translate3d(0, 0, 0);
    opacity: 1;
    margin-top: 110px;
  }
  100% {
    transform: rotate(360deg) translate3d(0, 50%, 0);
    opacity: 0;
  }
}
@-webkit-keyframes fadeOutDown {
  0% {
    transform: rotate(360deg) translate3d(0, 0, 0);
    opacity: 1;
  }
  40% {
    transform: rotate(360deg) translate3d(0, 0, 0);
    opacity: 1;
    margin-top: 110px;
  }
  100% {
    transform: rotate(360deg) translate3d(0, 50%, 0);
    opacity: 0;
  }
}

.fadeOutDown {
  -webkit-animation-name: fadeOutDown !important;
  animation-name: fadeOutDown !important;
}

</style>

